/* Demande expresse d'exécution anticipée (article 8-4 des CGV), posée le 14/10/2026.
   Le bouton de paiement du tiroir et de la page panier attend que les deux cases soient cochées. Les cases sont rendues
   par snippets/hm-demande-expresse.liquid, juste avant le bouton : on les cherche dans le même parent. Écoute au niveau du
   document, en capture : le tiroir est redessiné à chaque changement du panier, ses éléments changent. */
(function () {
  if (window.hmDemandeExpresse) return;
  window.hmDemandeExpresse = true;
  function zoneDe(bouton) { var p = bouton.parentElement; return p ? p.querySelector('[data-hm-expresse]') : null; }
  function complet(zone) {
    var cases = zone.querySelectorAll('[data-hm-expresse-case]');
    for (var i = 0; i < cases.length; i++) { if (!cases[i].checked) return false; }
    return cases.length > 0;
  }
  function noterHeure(zone) {
    var h = zone.querySelector('[data-hm-expresse-heure]');
    if (h) h.value = complet(zone) ? new Date().toLocaleString('fr-FR', { timeZone: 'Europe/Paris' }) : '';
  }
  function retenir(e, zone) {
    e.preventDefault();
    e.stopImmediatePropagation();
    var aide = zone.querySelector('[data-hm-expresse-aide]');
    if (aide) aide.hidden = false;
    var cases = zone.querySelectorAll('[data-hm-expresse-case]');
    for (var i = 0; i < cases.length; i++) { if (!cases[i].checked) { cases[i].focus(); break; } }
  }
  document.addEventListener('change', function (e) {
    var c = e.target && e.target.closest ? e.target.closest('[data-hm-expresse-case]') : null;
    if (!c) return;
    var zone = c.closest('[data-hm-expresse]');
    if (!zone) return;
    noterHeure(zone);
    if (complet(zone)) { var aide = zone.querySelector('[data-hm-expresse-aide]'); if (aide) aide.hidden = true; }
  }, true);
  document.addEventListener('click', function (e) {
    var b = e.target && e.target.closest ? e.target.closest('button[name="checkout"]') : null;
    if (!b) return;
    var zone = zoneDe(b);
    if (!zone) return;
    if (complet(zone)) { noterHeure(zone); return; }
    retenir(e, zone);
  }, true);
  document.addEventListener('submit', function (e) {
    var b = e.submitter;
    if (!b || b.name !== 'checkout') return;
    var zone = zoneDe(b);
    if (zone && !complet(zone)) retenir(e, zone);
  }, true);
})();
